document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth >= 990) return;

  const sticky = document.getElementById("StickyATC");
  if (!sticky) return;

  const stickyButton = document.getElementById("StickyATCButton");
  const stickyVariant = document.getElementById("StickyATCVariant");
  const variants = JSON.parse(
    document.querySelector('textarea[data-variant-json]').value);

  // Find the REAL add to cart button
  const originalButton =
    document.querySelector('[data-add-to-cart]') ||
    document.querySelector('button[name="add"]') ||
    document.querySelector('button[type="submit"][name="add"]');

  if (!originalButton) {
    console.warn("Sticky ATC: Original Add To Cart button not found.");
    return;
  }

  // Find the original product form
  const productForm = originalButton.closest("form");

  if (!productForm) {
    console.warn("Sticky ATC: Product form not found.");
    return;
  }

// --------------------------
// Show / Hide
// --------------------------

function updateStickyATC() {

    const buttonRect = originalButton.getBoundingClientRect();

    // Position of the bottom of the original ATC in the document
    const triggerPoint =
        window.scrollY +
        buttonRect.top +
        buttonRect.height;

    // Only show AFTER scrolling past the button
    if (window.scrollY > triggerPoint) {
        sticky.classList.add("sticky-atc--visible");
    } else {
        sticky.classList.remove("sticky-atc--visible");
    }

}

window.addEventListener("scroll", updateStickyATC, {
    passive: true
});

window.addEventListener("resize", updateStickyATC);

updateStickyATC();

  // --------------------------
  // Sticky button submits
  // original form
  // --------------------------

  stickyButton.addEventListener("click", function(){

      originalButton.click();

  });

  // --------------------------
  // Sync variant dropdown
  // --------------------------

  if(stickyVariant){

      const masterSelect =
          productForm.querySelector('select[name="id"]');

      if(masterSelect){

            stickyVariant.addEventListener("change", function () {

                const variantId = Number(this.value);

                const variant = variants.find(v => v.id === variantId);

                if (!variant) return;

                const optionValues = [
                    variant.option1,
                    variant.option2,
                    variant.option3
                ];

                optionValues.forEach(function(value, index){

                    if (!value) return;

                    const input = document.querySelector(
                        '[data-variant-input][data-index="option' + (index + 1) + '"][value="' + value + '"]'
                    );

                    if (input && !input.checked) {
                        input.click();
                    }

                });

            });

          masterSelect.addEventListener("change", function(){

              stickyVariant.value = this.value;

          });

      }

  }

const stickyPriceCurrent = document.querySelector(".sticky-atc__price-current");
const stickyPriceCompare = document.querySelector(".sticky-atc__price-compare");

document.addEventListener("variant:change", function (event) {

    const variant = event.detail.variant;

    if (!variant) return;

    stickyPriceCurrent.textContent = Shopify.formatMoney(
        variant.price,
        theme.settings.moneyFormat
    );

    if (variant.compare_at_price > variant.price) {

        if (!stickyPriceCompare) return;

        stickyPriceCompare.style.display = "";
        stickyPriceCompare.textContent = Shopify.formatMoney(
            variant.compare_at_price,
            theme.settings.moneyFormat
        );

    } else if (stickyPriceCompare) {

        stickyPriceCompare.style.display = "none";

    }

});

// --------------------------
// Sync sticky price
// --------------------------

const pagePrice = document.querySelector("[data-product-price]");
const stickyPrice = document.querySelector(".sticky-atc__price-current");

if (pagePrice && stickyPrice) {

    const observer = new MutationObserver(function () {

        stickyPrice.textContent = pagePrice.textContent.trim();

    });

    observer.observe(pagePrice, {
        childList: true,
        characterData: true,
        subtree: true
    });

    // Initial sync
    stickyPrice.textContent = pagePrice.textContent.trim();

}

});

